'use client';

import { useCallback, useSyncExternalStore } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const subscribe = useCallback((onStoreChange: () => void): () => void => {
    const mediaQueryList = window.matchMedia(query);
    mediaQueryList.addEventListener('change', onStoreChange);

    return (): void => {
      mediaQueryList.removeEventListener('change', onStoreChange);
    };
  }, [query]);

  const getSnapshot = useCallback((): boolean => window.matchMedia(query).matches, [query]);
  const getServerSnapshot = (): boolean => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
